module.exports = __webpack_public_path__ + "img/column_title.757816c7.png";